import { FC, useMemo } from 'react';

import { OptimizedImage } from '../optimized-image/optimized-image';
import { clsx } from 'clsx';
import { useMediaQuery } from 'usehooks-ts';

import { InfoBanner, InfoBannerType } from 'shared/components/ui/InfoBanner/InfoBanner';

import styles from './MoveStatusRenderer.module.css';
import { MoveStatusRendererProps } from './MoveStatusRenderer.types';
import { getStatusIcon } from './MoveStatusRenderer.utils';

export const MoveStatusRenderer: FC<MoveStatusRendererProps> = ({
  type = InfoBannerType.INFO,
  className = '',
  statusIcon,
  title,
  infoBannerClassName = '',
  hideIconOnMobile = false,
}) => {
  const isShortScreen = useMediaQuery('(max-height: 400px)');

  const iconData = useMemo(() => {
    if (hideIconOnMobile || isShortScreen) return null;
    return getStatusIcon(statusIcon);
  }, [hideIconOnMobile, isShortScreen, statusIcon]);

  const borderClassName = useMemo(
    () =>
      clsx(
        'h-[1px] w-full',
        type === InfoBannerType.WARNING
          ? 'bg-loader-border-warning'
          : type === InfoBannerType.WAITING
            ? 'bg-loader-border-waiting'
            : 'bg-loader-border',
      ),
    [type],
  );

  return (
    <div className={clsx('flex flex-col items-center justify-center', className)}>
      {iconData && (
        <div className={styles.icon}>
          <OptimizedImage imageData={iconData} alt={statusIcon} />
        </div>
      )}

      <div className={borderClassName} />
      {title && <InfoBanner message={title} type={type} className={infoBannerClassName} />}
      <div className={borderClassName} />
    </div>
  );
};
